import axios from 'axios';

// 创建 axios 实例
const service = axios.create({
  baseURL: '/api', // 修改为与代理配置匹配的路径
  timeout: 15000, // 请求超时时间，15秒
  headers: {
    'Content-Type': 'application/json;charset=utf-8',
  },
});

// 请求拦截器
service.interceptors.request.use(
  (config) => {
    // 这里可以添加一些通用的请求处理逻辑
    // 例如：添加时间戳防止缓存
    if (config.method === 'get') {
      config.params = {
        ...config.params,
        _t: Date.now(),
      };
    }
    return config;
  },
  (error) => {
    console.error('请求错误:', error);
    return Promise.reject(error);
  }
);

// 响应拦截器
service.interceptors.response.use(
  (response) => {
    const res = response.data;

    // 这里可以根据后端的数据结构进行统一处理
    // 例如：检查状态码、提取数据等
    if (res.code && res.code !== 200) {
      console.error('接口错误:', res.message || '未知错误');
      return Promise.reject(new Error(res.message || '未知错误'));
    }
    return res;
  },
  (error) => {
    console.error('响应错误:', error);
    return Promise.reject(error);
  }
);

export default service;
